import React, { useState } from 'react';
import { DiscoverUser } from '../../types/discover';

interface MatchInvitationModalProps {
  user?: DiscoverUser; // Optional — e.g. WaitlistModal passes onSendInvitation with target in closure
  isOpen: boolean;
  onClose: () => void;
  onSendInvitation: (message: string) => void;
  loading?: boolean;
}

const MatchInvitationModal: React.FC<MatchInvitationModalProps> = ({
  isOpen,
  onClose,
  onSendInvitation,
  loading = false
}) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    onSendInvitation(message);
    setMessage('');
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-cream border-2 border-coffee rounded-xl p-6 shadow-[4px_4px_0px_#594A42] max-w-md w-full mx-4">
        <h3 className="text-coffee font-semibold text-lg mb-4">Send Match Invitation</h3>

        <div className="mb-6">
          <label className="text-coffee/80 font-medium text-sm mb-2 block">Message (Optional)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Please provide additional details..."
            className="w-full bg-white text-coffee border border-coffee/30 rounded-lg px-3 py-2 placeholder-coffee/40 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta shadow-inner h-20 resize-none"
          />
        </div>

        <div className="flex space-x-2">
          <button
            onClick={handleClose}
            disabled={loading}
            className="flex-1 bg-white border-2 border-coffee text-coffee px-4 py-2 rounded-lg hover:bg-cream transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSend}
            disabled={loading}
            className="flex-1 bg-terracotta text-white border-2 border-coffee px-4 py-2 rounded-lg hover:bg-[#d89050] transition-colors disabled:opacity-50"
          >
            {loading ? 'Sending...' : 'Send Invitation'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchInvitationModal;
